/**<params config data>说明
 * titleFontSize 标题文字大小 number
 * titleColor 标题文字颜色 string
 * desFontSize 描述文字大小 number
 * desColor 描述文字颜色 string
 * background 颜色：string
 * textAlign  文本框对齐 string  left center right
 * itemsColor  底部大文字颜色 string
 * itemsbomColor  底部小文字颜色 string
 * position 定位 string
 * data 数据 array
 */
import { Player, ControlBar, ReplayControl, PlayToggle, BigPlayButton, CurrentTimeDisplay, TimeDivider, VolumeMenuButton } from 'video-react';
import EFLoad from '@/components/UI/svg/Icons/EFLoad';
import EFPause from '@/components/UI/svg/Icons/EFPause';
import EFPlay from '@/components/UI/svg/Icons/EFPlay';
import { useGlobal } from '@/utils/useGlobal';
import 'video-react/dist/video-react.css';
import css from './index.module.scss';

const configs = {
    bgColor: '#000',
    navColor: '#fff',
    listColor: '#fff',
    src: '/video/op.mp4',
    height: '720px',
    autoPlay: false,
    hideControl: false,
    disableDefaultControls: false,
    isShowTip: false,
    muted: false,
    loop: false,
};
export default function VideoModule({ config }: any) {
    const { useState } = useGlobal();
    const [playerBox, setPlayerBox] = useState({});
    const configTypes = { ...configs, ...config };
    const play = () => {
        playerBox.play();
    };
    const pause = () => {
        playerBox.pause();
    };
    const load = () => {
        playerBox.load();
    };

    return (
        <div className={`${css.VideoModule} videoModules`} style={{ background: configTypes.bgColor }}>
            <div className="video-wrap" style={{ height: configTypes.height }}>
                <Player
                    className="videos"
                    src={configTypes.src}
                    ref={(c: any) => {
                        setPlayerBox(c);
                        return playerBox;
                    }}
                    playsInline
                    fluid={true}
                    autoPlay={configTypes.autoPlay}
                    muted={configTypes.muted}
                    loop={configTypes.loop}
                >
                    {/* <source src="/video/op.mp4"/> */}

                    <BigPlayButton position="center" />
                    <ControlBar disableDefaultControls={configTypes.disableDefaultControls} className={configTypes.hideControl ? 'hideControl' : ''}>
                        <ReplayControl seconds={10} order={1.1} />
                        <PlayToggle />
                        <CurrentTimeDisplay order={4.1} />
                        <TimeDivider order={4.2} />
                        <VolumeMenuButton vertical rates={[5, 2, 1, 0.5, 0.1]} order={7.1} />
                    </ControlBar>
                    <div className="play-tip" style={{ display: configTypes.isShowTip ? 'block' : 'none' }}>
                        <span onClick={load}>
                            <EFLoad />
                        </span>
                        <span onClick={pause}>
                            <EFPause />
                        </span>
                        <span onClick={play}>
                            <EFPlay />
                        </span>
                    </div>
                </Player>
            </div>
        </div>
    );
}
